/**
 * @param element {Element}
 * @param dataComponent {string}
 * @param child {Node | string}
 * @return {void}
 */
module.exports = function appendToComponent(element, dataComponent, child) {
    const component = element.querySelector(`[data-component="${dataComponent}"]`)

    if (component instanceof Element) {
        component.append(child);
    }
}